import { AuthConfig } from 'angular-oauth2-oidc';


  const oauthConfig: AuthConfig = {
    loginUrl: 'https://portaldev.hdinhd.org/oauth/authorize/',
    clientId: 'RYrOIFfh39u5tR1JWUrg1AxDwQNlcG',
    dummyClientSecret: 'yMVWYMK0wKL9Ellc2UIKr7Xw072pbe',
    redirectUri: 'https://gem-test.rbsprod.net/',
    tokenEndpoint: 'https://portaldev.hdinhd.org/oauth/token',
    userinfoEndpoint: 'https://portaldev.hdinhd.org/oauth/me/',
  };

  export const environment = {
    name: 'test',
    prod: false,
    oauthConfig,
    baseUrl: 'https://gem-test.rbsprod.net/api/',
  };
  